<template>
  <div class="metric-grid">
    <slot></slot>
  </div>
</template>

<script setup>
// no props yet; simple layout wrapper
</script>

<style scoped>
.metric-grid{display:flex;flex-wrap:wrap;gap:8px}
@media (max-width:640px){.metric-grid{flex-direction:column}}
</style>
